<template>
    <span v-if="!editable" class="static-wrapper">
            <MapCoordinates v-if="!locationDescription || !locationDescription.length" :coordinates="{lat: latitude, lng: longitude}"/>
            <template v-for="(locationPart, index) in (!locationDescription ? [] : locationDescription.split(/(.*?,\s*)/).filter(item => item !== ''))"><span v-bind:key="index" class="address-component">{{locationPart}}</span></template>
                <a target="_blank" :href="`https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`">
                    <img src="@/assets/google-directions.png"
                         alt="Get directions on Google Maps"
                         title="Get directions on Google Maps"
                         class="directions-link"
                    />
                </a>
    </span>
    <span v-else class="editWrapper">
        <EditableLocationAutocomplete
                :currentCoordinates="currentCoordinates"
                :currentLocation="currentLocation"
                :autocompleteSessionTokenPromise = "autocompleteSessionTokenPromise"
                v-bind:locationDescription = "locationDescription"
                :locationCoordinates = "(latitude && longitude)? {lat: latitude, lng: longitude} : null"
                @select="$emit('select', $event)"
        />
        <div class="coordinates" v-if="latitude && longitude">
            <MapCoordinates :coordinates="{lat: latitude, lng: longitude}"/>
        </div>
    </span>

</template>
<style scoped lang="scss">
    .directions-link {
        width: 1em;
        height: 1em;
        user-select: none;
        display: inline-block;
        cursor: pointer;
        //position: absolute;
        //margin-left: 22px;
        //left: 1em;
        margin-left: .25em;
        align-self: center;
    }

    .address-component {
        display: inline-block;
        //white-space: pre TODO: is this needed?
    }

    .coordinates {
        margin-top: 0.5em;
        margin-bottom: 0.25em;
    }
    .static-wrapper {
        position: relative;
        display: flex;
        //align-items: center;
        //flex-direction: column;
        flex-wrap: wrap;
        div {
            line-height: 1.25;
        }
    }
    .editWrapper {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        //align-items: center;
    }

    .li-border-top {
        //TODO NEW CLASS FOR THIS
        //font-size: 14px;
        border-top: lightgrey 1px solid;
    }

</style>

<script>
    import {once} from 'lodash-es';
  import axios from 'axios';
  export default {
    name: "EditableLocation",
    data() {
      return {
        position: {},
        currentLocation: "Loading Current Location...",
        showMapSelector: false,
        input: null,
        autocompleteSessionTokenPromise: null
      }
    },
    props: {
      editable: Boolean,
      locationDescription: String,
      latitude: Number,
      longitude: Number,
      map: null
    },
    mounted() {
      this.autocompleteSessionTokenPromise = this.$googlePromise.then(() => new google.maps.places.AutocompleteSessionToken());
    },
    watch: {
      editable: {
        initial: true,
        handler: function(editable) {
          if (editable) {
            this.getCurrentLocation();
          }
        }
      }
    },
    methods: {
      getCurrentLocation: once(function() {
        let handleLocationError = console.log;
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            position => {
              this.position = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              };
              this.$googlePromise.then(() => {
                new google.maps.Geocoder().geocode({location: this.position}, results => {
                  if (results[0]) {
                    this.currentLocation = results[0];
                  }
                });
              });
            },
            function (a) {
              window.a = a;
              handleLocationError(a);
            }
          );
        } else {
          // Browser doesn't support Geolocation
          handleLocationError(false, infoWindow, map.getCenter());
        }
      })
    },
    computed: {
      currentCoordinates: function () {
        let pos = this.position;
        if (typeof pos.lat === "number" && typeof pos.lng === "number") {
          return pos;
        } else {
          return undefined;
        }
      },
    }

  }
</script>

